export * from "./src/index.js";
export * as core from "./src/core/index.js";
export * as parse from "./src/parse/index.js";
export * as load from "./src/load/index.js";
export * as ssr from "./src/ssr/index.js";
export * as negotiate from "./src/negotiate/index.js";
import * as _nested0 from "./src/data/ordinal.js";
import * as _nested1 from "./src/data/ranges.js";
export const data = Object.freeze({ ordinal: _nested0, ranges: _nested1 });